
const addHistoricalDataToQuestions = (data, historicalData) => {
  const {questions: {results: originalResults = [], ...questionsMeta} = {}} = data
  const {questions: {results: historicalResults = []} = {}} = historicalData

  const results = originalResults.map((question) => {
    const hQuestion = historicalResults.find(({id: hId}) => (hId === question.id)) || {}
    return {...question, historicalQuestionStats: hQuestion.questionStats || null}
  }) || []

  return {results, ...questionsMeta}
}

export default addHistoricalDataToQuestions
